module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/init/fr.json
// module id = 179
// module chunks = 6